import type { InspectionChartDependencies } from 'charts/common/useInspectionChartDependencies';
import { AnalyticsTranslationKeys, CommonTranslationKeys, InspectionTranslationKeys } from 'intl/keys';
import { FilterActionCalls } from './types';
import {
  CompletedInspectionsByTemplateFilters,
  FilterTypes,
  StrictDateRange,
} from 'shared/types/analytics';
import { sanitizeDateFilterValue } from 'charts/common/model';
import { createLabels } from 'charts/common/filters';

export function createFiltersForView(
  {
    filters,
    managers,
    processes,
    sites,
    timezone,
  }: InspectionChartDependencies,
  {
    setDateRange,
    setManagers,
    setProcesses,
    setSites,
  }: Pick<
    FilterActionCalls,
    'setDateRange' | 'setProcesses' | 'setSites' | 'setManagers'
  >
): CompletedInspectionsByTemplateFilters {
  const completedFilters = filters as CompletedInspectionsByTemplateFilters;
  const [
    dateRangeFilter,
    processesFilter,
    sitesFilter,
    managersFilter,
  ] = completedFilters.dataScope.filters;

  return {
    dataScope: {
      labelId: AnalyticsTranslationKeys.tab,
      filters: [
        {
          labelId: AnalyticsTranslationKeys.dateRange,
          type: FilterTypes.daterange,
          value: {
            from: sanitizeDateFilterValue(
              dateRangeFilter.value.from,
              timezone
            ),
            to: sanitizeDateFilterValue(
              dateRangeFilter.value.to,
              timezone
            ),
          },
          setter: (value: StrictDateRange): void => {
            setDateRange(value);
          },
        },
        {
          labelId: CommonTranslationKeys.process,
          type: FilterTypes.multiselect,
          available: processes,
          labels: createLabels(processes),
          value: processesFilter.value,
          setter: (value: string[]): void => {
            setProcesses(value);
          },
        },
        {
          labelId: AnalyticsTranslationKeys.sites,
          type: FilterTypes.multiselect,
          available: sites,
          labels: createLabels(sites),
          value: sitesFilter.value,
          setter: (value: string[]): void => {
            setSites(value);
          },
        },
        {
          labelId: InspectionTranslationKeys.tableAuthor,
          type: FilterTypes.multiselect,
          available: managers,
          labels: createLabels(managers),
          value: managersFilter.value,
          setter: (value: string[]): void => {
            setManagers(value);
          },
        },
      ],
    },
  };
}
